const IconInsurance = () => (
  <svg
    width="36px"
    height="36px"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.322 8.25v4.796H7.574v3.3h4.748v4.797h3.3v-4.797h4.457v-3.3h-4.457V8.25h-3.3Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m14.305.59 11.563 2.882c.361.09.644.266.847.526.204.26.305.57.305.932v11.563c0 2.35-.621 4.487-1.864 6.408-1.244 1.9-2.623 3.532-4.137 4.9-1.515 1.368-2.928 2.436-4.239 3.204-1.333.769-2.068 1.187-2.204 1.255a.35.35 0 0 1-.237.152c-.09.012-.204.017-.34.017-.135 0-.248-.005-.338-.017a.35.35 0 0 1-.238-.152c-.135-.068-.87-.486-2.204-1.255-1.31-.768-2.723-1.836-4.238-3.204-1.515-1.368-2.894-3-4.137-4.9C1.601 20.98.98 18.844.98 16.493V4.93c0-.362.096-.672.288-.932.193-.26.436-.436.73-.526L13.558.59h.746Zm8.579 20.48a8.888 8.888 0 0 0 1.254-4.577V6.083L14 3.472 3.86 6.082v10.41a9.01 9.01 0 0 0 1.255 4.646 18.57 18.57 0 0 0 2.95 3.815c1.13 1.119 2.26 2.051 3.39 2.797 1.109.769 1.956 1.311 2.544 1.628a60.622 60.622 0 0 0 2.543-1.696c1.13-.79 2.26-1.74 3.39-2.848a18.554 18.554 0 0 0 2.95-3.764Z"
      fill="#fff"
    />
  </svg>
);

export default IconInsurance;
